import { IconButton } from "../button/icon-button";
import { CopyIcon } from "../icons/copy-icon";
import { notifyError, notifySuccess } from "../notifications/notifications";

export const handleCopy = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    notifySuccess({ message: "Copied to clipboard." });
  } catch (error) {
    notifyError({ message: "Failed to copy to clipboard.", error });
  }
};

export const CopyButton: React.FC<{ toCopy: string }> = ({ toCopy }) => {
  return <IconButton onClick={() => handleCopy(toCopy)} icon={<CopyIcon />} />;
};
